var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [_vm._v(_vm._s(_vm.drug.title))]),
    _vm._v(" "),
    +_vm.drug.pack_set !== 1
      ? _c("p", [
          _vm._v("Препарат комплектный: "),
          _c("span", { staticClass: "badge badge-info" }, [
            _vm._v("1 комплект"),
          ]),
          _vm._v(" -\n      "),
          _c("strong", [_vm._v(_vm._s(_vm.drug.pack_set))]),
          _vm._v("\n      (зав.уп.)"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.drug.cool
      ? _c("p", [
          _c("span", { staticClass: "icon icon-snowflake" }),
          _vm._v(" необходим хладогент"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.drug.pack_box_comment
      ? _c("p", { staticClass: "pack_box_comment" }, [
          _vm._v("\n      " + _vm._s(_vm.drug.pack_box_comment)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }